/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  WorkOSDomainVerificationIntentOptions,
  WorkOSDomainVerificationIntentOptions$Outbound,
  WorkOSDomainVerificationIntentOptions$outboundSchema,
} from "./workosdomainverificationintentoptions.js";
import {
  WorkOSSSOIntentOptions,
  WorkOSSSOIntentOptions$Outbound,
  WorkOSSSOIntentOptions$outboundSchema,
} from "./workosssointentoptions.js";

export type WorkOSIntentOptions = {
  domainVerification?: WorkOSDomainVerificationIntentOptions | undefined;
  sso?: WorkOSSSOIntentOptions | undefined;
};

/** @internal */
export type WorkOSIntentOptions$Outbound = {
  domain_verification?:
    | WorkOSDomainVerificationIntentOptions$Outbound
    | undefined;
  sso?: WorkOSSSOIntentOptions$Outbound | undefined;
};

/** @internal */
export const WorkOSIntentOptions$outboundSchema: z.ZodMiniType<
  WorkOSIntentOptions$Outbound,
  WorkOSIntentOptions
> = z.pipe(
  z.object({
    domainVerification: z.optional(
      WorkOSDomainVerificationIntentOptions$outboundSchema,
    ),
    sso: z.optional(WorkOSSSOIntentOptions$outboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      domainVerification: "domain_verification",
    });
  }),
);

export function workOSIntentOptionsToJSON(
  workOSIntentOptions: WorkOSIntentOptions,
): string {
  return JSON.stringify(
    WorkOSIntentOptions$outboundSchema.parse(workOSIntentOptions),
  );
}
